import styled from '@emotion/styled';

export const DialogContainer = styled.div`
    padding: 24px;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 24px;
    max-height: 80vh;
    overflow-y: auto;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const FieldGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Field = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const FieldLabel = styled.label`
    font-weight: 600;
    font-size: 14px;
    color: #374151;
`;

export const FieldValue = styled.div`
    font-size: 14px;
    color: #6B7280;
    padding: 8px 12px;
    background-color: #F9FAFB;
    border: 1px solid #E5E7EB;
    border-radius: 6px;
    min-height: 20px;
`;

export const StatusBadge = styled.div<{ status: string }>`
    display: inline-block;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
    width: fit-content;
    
    ${({ status }) => {
        switch (status) {
            case 'APPROVED':
                return `
                    background-color: #D1FAE5;
                    color: #065F46;
                    border: 1px solid #A7F3D0;
                `;
            case 'DENIED':
                return `
                    background-color: #FEE2E2;
                    color: #991B1B;
                    border: 1px solid #FECACA;
                `;
            case 'PENDING':
                return `
                    background-color: #FEF3C7;
                    color: #92400E;
                    border: 1px solid #FDE68A;
                `;
            case 'SUBMITTED':
                return `
                    background-color: #DBEAFE;
                    color: #1E40AF;
                    border: 1px solid #BFDBFE;
                `;
            default:
                return `
                    background-color: #F3F4F6;
                    color: #374151;
                    border: 1px solid #D1D5DB;
                `;
        }
    }}
`;

export const DocumentSection = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const DocumentViewer = styled.div`
    border: 1px solid #E5E7EB;
    border-radius: 6px;
    min-height: 200px;
    background-color: #F9FAFB;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const DocumentPlaceholder = styled.div`
    text-align: center;
    color: #6B7280;
    font-size: 14px;
    
    small {
        color: #9CA3AF;
        font-size: 12px;
    }
`;

export const Actions = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 16px;
    border-top: 1px solid #E5E7EB;
`;

